export function sanitisedHtml(item) {
  const regex = /(<([^>]+)>)/ig;
  if (item) {
    return item.replace(regex, '');
  }
  return item;
}

export default sanitisedHtml;
